<template>
  <ion-header>
    <ion-toolbar>
      <ion-title class="ion-text-center"
        ><strong>{{ translate("Product") }}: </strong> {{ id }}</ion-title
      >
      <ion-buttons slot="end">
        <ion-button @click="dismissModal()">{{
          translate("Close")
        }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-item>
        <ion-label>
          <strong>{{ translate("Product") }}: </strong> {{ name }}
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <strong>{{ translate("Quantity") }}: </strong> {{ quantity }}
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="ion-text-wrap">
          <strong>{{ translate("Description") }}: </strong> {{ description }}
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <strong>{{ translate("typeOfMaterial") }}: </strong>
          {{ ts === 0 ? translate("normalMaterial") : translate("tsMaterial") }}
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</template>

<script>
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonButtons,
  modalController,
} from "@ionic/vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ProductModal",
  props: {
    id: {
      type: Number,
    },
    quantity: {
      type: Number,
    },
    description: {
      type: String,
    },
    name: {
      type: String,
    },
    ts: {
      type: Number,
    },
  },
  components: {
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonList,
    IonItem,
    IonLabel,
    IonButton,
    IonButtons,
  },
  methods: {
    async dismissModal() {
      await modalController.dismiss();
    },
  },
});
</script>

<style>
</style>